import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Archive, Bell, FileText, Menu, X } from 'lucide-react';

const Sidebar = () => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  const navItems = [
    { name: 'Win/Loss Archive', icon: Archive, path: '/' },
    { name: 'Notification Center', icon: Bell, path: '/notifications' },
    { name: 'Reports', icon: FileText, path: '/reports' },
  ];

  const toggleSidebar = () => setIsOpen(!isOpen);

  return (
    <>
      <button
        className="lg:hidden fixed top-4 left-4 z-20 p-2 bg-white rounded-md shadow-md"
        onClick={toggleSidebar}
      >
        {isOpen ? <X size={24} /> : <Menu size={24} />}
      </button>
      <nav className={`bg-white w-64 h-screen shadow-lg fixed left-0 top-0 z-10 transition-transform duration-300 ease-in-out transform ${isOpen ? 'translate-x-0' : '-translate-x-full'} lg:translate-x-0`}>
        <div className="p-4">
          <h1 className="text-2xl font-bold text-blue-800 font-lexend">Win/Loss Archive</h1>
          <p className="text-sm text-blue-600">by Buried Wins</p>
        </div>
        <ul className="space-y-1">
          {navItems.map((item) => (
            <li key={item.name}>
              <Link
                to={item.path}
                className={`flex items-center px-4 py-2 text-sm font-semibold transition-colors ${
                  location.pathname === item.path
                    ? 'text-blue-600 bg-blue-50 border-r-4 border-blue-600'
                    : 'text-blue-400 hover:text-blue-600 hover:bg-blue-50'
                }`}
                onClick={() => setIsOpen(false)}
              >
                <item.icon className="mr-2" size={20} />
                <span>{item.name}</span>
              </Link>
            </li>
          ))}
        </ul>
      </nav>
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-0 lg:hidden"
          onClick={toggleSidebar}
        ></div>
      )}
    </>
  );
};

export default Sidebar;